import { render, staticRenderFns } from "./ListItemFile.vue?vue&type=template&id=1ebdddc4"
import script from "./ListItemFile.vue?vue&type=script&lang=js"
export * from "./ListItemFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports